import React from 'react'
import { Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import ModalWrapper from './ModalWrapper'
import { BasicModalProps } from '../../types/modals'
import './SportsModal.css'
import './Modals.css'
import StoreButtons from '../Common/Buttons/StoreButtons'

const { Title, Paragraph } = Typography

interface SportDetails {
    title: string
    description: string
    image: {
        path: string
        alt: string
        pathMobile: string
        altMobile: string
    }
}

interface SportsModalProps extends BasicModalProps {
    sportDetails: SportDetails
}

export const SportsModal: React.FC<SportsModalProps> = ({
    isOpen,
    onClose,
    sportDetails,
}) => {
    const { t } = useTranslation()

    return (
        <ModalWrapper isOpen={isOpen} onClose={onClose} width={862}>
            <div
                data-testid={`${sportDetails.title.toLowerCase()}-modal`}
                className="modal-content"
            >
                <div className="sports-modal-container">
                    <div className="sports-modal-content">
                        <div className="text-container">
                            <Title className="title" level={2}>
                                {sportDetails.title}
                            </Title>
                            <Paragraph className="paragraph">
                                {sportDetails.description}
                            </Paragraph>
                            <div className="qr-store-buttons">
                                <div className="qr-code">
                                    <img
                                        src="/img/qrcode.webp"
                                        alt={t('common.alt.qrCode')}
                                    />
                                </div>
                                <StoreButtons main="store-buttons" />
                            </div>
                        </div>
                        <div className="image-group">
                            <div className="image">
                                <img
                                    src={sportDetails.image.path}
                                    alt={sportDetails.image.alt}
                                />
                            </div>
                        </div>
                        <div className="single-mobile-image">
                            <img
                                src={sportDetails.image.pathMobile}
                                alt={sportDetails.image.altMobile}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </ModalWrapper>
    )
}
